import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useTrackerContext } from "../../Contexts/TrackerContext";
import Appointments from "../../Components/Appointments";
import { CircularProgress } from "@mui/material";
import React, { useEffect } from "react";

export default function AllAppointments() {
  const {
    getUpcomingAppointments,
    upcomingAppointments,
    appointmentLoadState,
    handleCloseTracker,
  } = useTrackerContext();

  useEffect(() => {
    getUpcomingAppointments();
  }, []);

  let content = null;
  if (appointmentLoadState === "load") {
    content = (
      <div className="w-full flex justify-center items-center">
        <CircularProgress />
      </div>
    );
  } else {
    content = (
      <Appointments
        getUpcomingAppointments={getUpcomingAppointments}
        appointmentLoadState={appointmentLoadState}
        appointmentList={upcomingAppointments}
      />
    );
  }

  return (
    <div className="flex flex-col items-center min-h-screen max-w-screen sm:bg-[#E7EEFA] ">
      <div className="bg-white w-screen mb-[56px] sm:my-24 sm:w-148 h-auto rounded-xl">
        <div className="grid grid-cols-1 divide-y">
          <div className="flex flex-row p-3">
            <div className="text-center text-md font-bold flex-grow">
              Upcoming appointments
            </div>
            <CloseOutlinedIcon
              className=" cursor-pointer"
              onClick={() => handleCloseTracker()}
            />
          </div>
          <div className="p-3">{content}</div>
        </div>
      </div>
    </div>
  );
}
